import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './clientBookingDetails.css';

const ClientLaundryImages = ({ bookingId }) => {
    const [beforePhotos, setBeforePhotos] = useState([]);
    const [stainPhotos, setStainPhotos] = useState([]);
    const [damagePhotos, setDamagePhotos] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await axios.get(`/api/client-requests/bookings/${bookingId}/laundry-images`);
                const photos = response.data;

                setBeforePhotos(photos.filter((img) => img.type === 'before'));
                setStainPhotos(photos.filter((img) => img.type === 'stain'));
                setDamagePhotos(photos.filter((img) => img.type === 'damage'));
            } catch (error) {
                console.error("Failed to load images:", error);
            }
        };

        fetchImages();
    }, [bookingId]);

    const openModal = (type, index) => {
        setSelectedType(type);
        setStartIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedType(null);
        setStartIndex(0);
    };

    const renderPhotos = (photos, typeLabel) => (
        photos.length > 0 && (
            <div className="photos-section">
                <h5>{typeLabel}</h5>
                <div className="photos-grid">
                    {photos.map((photo, index) => (
                        <div key={photo.id} className="photo-item">
                            <img
                                src={photo.image_url}
                                alt={`Laundry ${index}`}
                                className="thumbnail"
                                onClick={() => openModal(typeLabel.toLowerCase(), index)}
                            />
                            {photo.item_name && (
                                <span className={`photo-badge ${photo.type === 'stain' ? 'stain' : 'damage'}`}>
                                    {photo.item_name}
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        )
    );

    const modalImages = {
        before: beforePhotos,
        stain: stainPhotos,
        damage: damagePhotos,
        'stained / damaged': [...stainPhotos, ...damagePhotos],
    };

    return (
        <div className="client-laundry-images">
            {renderPhotos(beforePhotos, 'Before')}
            {renderPhotos([...stainPhotos, ...damagePhotos], 'Unremovable Stains / Damages')}

            {isModalOpen && selectedType && (
                <div className="photo-modal-overlay" onClick={closeModal}>
                    <div className="photo-modal" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="modal-x" onClick={closeModal}>&times;</button>
                        <ImageGallery
                            items={modalImages[selectedType.toLowerCase()].map(photo => ({
                                original: photo.image_url,
                                thumbnail: photo.image_url
                            }))}
                            startIndex={startIndex}
                            showThumbnails={false}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            slideDuration={300}
                            showNav={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClientLaundryImages;
